<template>
  <j-modal
    centered
    :title="name + '选择'"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    @cancel="close"
    cancelText="关闭" >

    <a-row :gutter="18">
      <a-col :span="16">
        <!-- 查询区域 -->
        <a-form layout="inline" class="j-inline-form">
          <!-- 固定条件 -->
          <a-form-item :label="(queryParamText||name)">
            <j-input style="width:350px;" v-model="queryParam[queryParamCode||valueKey]" :placeholder="'请输入' + (queryParamText||name)" @pressEnter="searchQuery"/>
          </a-form-item>
          <!-- 动态生成的查询条件 -->
          <j-select-biz-query-item v-if="queryConfig.length>0" v-show="showMoreQueryItems" :queryParam="queryParam" :queryConfig="queryConfig" @pressEnter="searchQuery"/>
          <!-- 按钮 -->
          <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
          <a v-if="queryConfig.length>0" @click="showMoreQueryItems=!showMoreQueryItems" style="margin-left: 8px">
            {{ showMoreQueryItems ? '收起' : '展开' }}
            <a-icon :type="showMoreQueryItems ? 'up' : 'down'"/>
          </a>
        </a-form>

        <a-table
          size="middle"
          bordered
          :rowKey="rowKey"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ y: 400 }"
          :rowSelection="{selectedRowKeys, onChange: onSelectChange, type: multiple ? 'checkbox':'radio'}"
          :customRow="customRowFn"
          @change="handleTableChange">
        </a-table>

      </a-col>
      <a-col :span="8">
        <a-card :title="'已选' + name" :bordered="false" :head-style="{padding:0}" :body-style="{padding:0}">

          <a-table size="middle" :rowKey="rowKey" bordered v-bind="selectedTable">
              <span slot="action" slot-scope="text, record, index">
                  <a @click="handleDeleteSelected(record, index)">删除</a>
              </span>
          </a-table>

        </a-card>
      </a-col>
    </a-row>
  </j-modal>
</template>

<script>
import Ellipsis from '@/components/Ellipsis'
import { FzisListMixin } from '@/mixins/FzisListMixin'
import { cloneObject, pushIfNotExist } from '@/utils/util'
import JSelectBizQueryItem from "@comp/fzisbiz/JSelectBizComponent/JSelectBizQueryItem";

export default {
  name: 'JSelectPrSubjectModal',
  mixins: [FzisListMixin],
  components: {Ellipsis,JSelectBizQueryItem },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default:'id'
    },
    width: {
      type: Number,
      default: 1000
    },
    // 查询配置
    queryConfig: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: String,
      default: 'id'
    },
  },
  data() {
    return {
      innerValue: [],
      multiple:false,
      queryParam:{},
      name:"标的",
      queryParamText:"标的名称",
      queryParamCode:"staffName",
      columns: [
        { title: '标的名称', dataIndex: 'subjectName', align: 'center', width: '30%' },
        { title: '标的编号', dataIndex: 'subjectCode', align: 'center', width: '50%' },
        { title: '标的类型', dataIndex: 'subjectType_dictText', align: 'center', width: '50%' },
      ],
      // 已选择列表
      selectedTable: {
        pagination: false,
        scroll: { y: 400 },
        columns: [
          { title: '标的名称', dataIndex: 'subjectName', align: 'center', width: '30%' },
          { title: '标的编号', dataIndex: 'subjectCode', align: 'center', width: '50%' },
          { title: '标的类型', dataIndex: 'subjectType_dictText', align: 'center', width: '50%' },
        ],
        dataSource: [],
      },
      url: {
        list: "/ebid-ce/propertyright/prSubjectTransfer/distribution/page",
      },
      options: [],
      dataSourceMap: {},
      showMoreQueryItems: false,
      dataSource:[],
      index:'',
      visible:false,
      isFinishFill:false,
      identifyCode:'',
      enterpriseId:'',
      staffId:'',
      disableMixinCreated:true,
    }
  },
  created() {
  },
  watch:{
    dataSource(value){
      if (this.isFinishFill){
        for (let data of this.dataSource){
          if(data[this.rowKey] == this.identifyCode){
            pushIfNotExist(this.selectedTable.dataSource,data,this.rowKey)
            pushIfNotExist(this.selectedRowKeys,this.identifyCode)
          }
        }
      }
    },
  },
  methods: {
    /** 关闭弹窗 */
    close() {
      // this.$emit('update:visible', false)
      this.visible = false
    },

    /** 完成选择 */
    handleOk() {
      this.$emit('setSubject', this.selectedTable.dataSource,this.index)
      this.close()
    },
    /** 删除已选择的 */
    handleDeleteSelected(record, index) {
      this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(record[this.rowKey]), 1)
      this.selectedTable.dataSource.splice(this.selectedTable.dataSource.indexOf(record), 1)
      this.innerValue.splice(this.innerValue.indexOf(record[this.valueKey]), 1)
    },

    customRowFn(record) {
      return {
        on: {
          click: () => {
            let key = record[this.rowKey]
            if (!this.multiple) {
              this.selectedRowKeys = [key]
              this.selectedTable.dataSource = [record]
            } else {
              let index = this.selectedRowKeys.indexOf(key)
              if (index === -1) {
                this.selectedRowKeys.push(key)
                this.selectedTable.dataSource.push(record)
              } else {
                this.handleDeleteSelected(record, index)
              }
            }
          }
        }
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      this.selectedTable.dataSource = []
      for(let i in selectionRows)
      {
        pushIfNotExist(this.selectedTable.dataSource,selectionRows[i],this.rowKey)
      }
    },
    getSubject(index){
      this.index = index
      this.visible = true
      this.isFirstLoad = true
    },
    selectedKeys(isFinishFill,identifyCode){
      this.isFinishFill = isFinishFill
      this.identifyCode = identifyCode
      this.selectedTable.dataSource = []
      this.selectedRowKeys=[]
      this.ipagination.current = 1

    },
    reloadData()
    {
      this.selectedTable.dataSource = []
      this.selectedRowKeys=[]
      //this.queryParam.isDistribution="0";
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
.full-form-item {
  display: flex;
  margin-right: 0;

  /deep/ .ant-form-item-control-wrapper {
    flex: 1 1;
    display: inline-block;
  }
}

.j-inline-form {
  /deep/ .ant-form-item {
    margin-bottom: 12px;
  }

  /deep/ .ant-form-item-label {
    line-height: 32px;
    width: auto;
  }

  /deep/ .ant-form-item-control {
    height: 32px;
    line-height: 32px;
  }
}
</style>